import { Literal, Union } from "runtypes";

export const IndicatorType = Union(Literal("fmv"), Literal("buy_sell"));

export type IndicatorType = typeof IndicatorType.alternatives[number]["value"];
